module.exports = {"TXTWCL_All_N0_Markets":{"id":"TXTWCL_All_N0_Markets","defaultMessage":"{0} – wszystkie kategorie zakładów"}}